export default __webpack_public_path__ + "static/media/graphic-no-area.fd86b7d7.svg";